import { render, staticRenderFns } from "./MultilayerPlate.vue?vue&type=template&id=98471b44&scoped=true&"
import script from "./MultilayerPlate.vue?vue&type=script&lang=js&"
export * from "./MultilayerPlate.vue?vue&type=script&lang=js&"
import style0 from "./MultilayerPlate.vue?vue&type=style&index=0&id=98471b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98471b44",
  null
  
)

component.options.__file = "MultilayerPlate.vue"
export default component.exports